<template>
	<section class="flex-module container-fluid flexible-email-columns">
		<div class="row">
			<div v-if="item?.title"
				 class="col-xs-12">
				<h2 class="section-title">
					{{ item.title }}
				</h2>
			</div>
		</div>
		<div class="row">
			<div v-for="(column, index) in item.email_columns"
				 :key="index"
				 class="col-xs-12 col-md-5 col-xxl-4 email-column">
				<h3 class="column-title">
					{{ column.title }}
				</h3>

				<a v-if="column.email"
				   :href="`mailto:${column.email}`"
				   class="column-link"
				   data-cursor-custom
				   data-cursor-text="Email us!">
					<!-- DIRECTUS TODO: obfuscate. See clickup todo doc -->
					{{ splitEmail(column.email).first }}@
					<br>
					<span class="obfi">ufglvbll</span>
					{{ splitEmail(column.email).second }}
				</a>
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true
	}
})

const item = computed(() => props.data.item)

function splitEmail(email) {
	if (!email) return false
	// const name = rot13(email.substring(0, email.lastIndexOf('@')))
	// const domain = rot13(email.substring(email.lastIndexOf('@') + 1))
	// const name = email.substring(0, email.lastIndexOf('@')).split('').reverse().join('')
	const name = email.substring(0, email.lastIndexOf('@')).split('').join('')
	const domain = email.substring(email.lastIndexOf('@') + 1)

	return { first: name, second: domain }
}
</script>

<style lang="scss" scoped>
.email-column {
	margin-bottom: rem-calc(72);

	@include for-devices-above(sm) {
		margin-bottom: rem-calc(100);
	}

	@include for-devices-above(sm) {
		margin-bottom: rem-calc(80);
	}

	.column-title {
		@include textBody;
		color: var(--details-color, $black);
	}

	.column-link {
		@include textH5;
		border: 0;
	}
}
</style>
